import { Box, Grid, InputLabel, TextField, Typography } from "@mui/material";
import { ReactComponent as VisibilityIcon } from "@/assets/images/icon_viewoff.svg";
import { ReactComponent as VisibilityOffIcon } from "@/assets/images/icon_viewon.svg";
import CustomInput from "@/components/CustomInput";
import OnboardLayout from "@/layout/components/OnboardLayout";
import { resetPassword } from "@/services/UserService";
import CommonUtil from "@/util/CommonUtils";
import { Button } from "antd";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function ResetPassword() {
  const { t } = useTranslation();
  const [visibility, setVisibility] = useState(true);
  const [confirmVisibility, setConfirmVisibility] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  var urlValue = window.location.href;
  var url = new URL(urlValue);
  var userIdentifierData = url.searchParams.get("e");
  var idData = url.searchParams.get("t");
  var companyCodeData = url.searchParams.get("c");

  const [payload, setPayload] = useState({
    id: "",
    password: "",
    confirmPassword: "",
    userIdentifier: "",
    companyCode: "",
  });

  const [error, setError] = useState({
    id: "",
    password: "",
    confirmPassword: "",
    userIdentifier: "",
    companyCode: "",
  });
  const handleSubmit = () => {
    if (validatePayload()) {
      var state = {
        ...payload,
        userIdentifier: userIdentifierData,
        id: idData,
        companyCode: companyCodeData,
      };
      resetPassword(state).then((response) => {
        if (response.data.code === "LVLI0012") {
          enqueueSnackbar(response.data.message, {
            variant: "success",
            anchorOrigin: {
              horizontal: "center",
              vertical: "top",
            },
            style: {
              marginTop: "300px",
            },
          });
          navigate("/");
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      });
    }
  };

  const validatePayload = () => {
    if (CommonUtil.isEmpty(payload.password)) {
      setError({
        ...error,
        password: t("LVL0001"),
      });
      return false;
    }

    if (!CommonUtil.isValidPassword(payload.password)) {
      setError({
        ...error,
        password: t("common.password_format"),
      });
      return false;
    }

    if (payload.password !== payload.confirmPassword) {
      setError({
        ...error,
        confirmPassword: t("LVLDAC0026"),
      });
      return false;
    }

    return true;
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
    setError({
      ...error,
      [name]: "",
    });
  };
  return (
    <OnboardLayout>
      <Typography variant="title">{t("LVLDAC0027")}</Typography>
      <Grid container spacing={2} px={2}>
        <Grid item xs={12}>
          <Box letiant="standard" style={{ width: "100%" }}>
            <InputLabel
              shrink
              htmlFor="bootstrap-input"
              style={{ paddingLeft: "0px", fontSize: "16px" }}
            >
              {t("LVLDAC0028")}
              <span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              name="password"
              placeholder={t("LVLDAC0028")}
              autoComplete="new-password"
              size="small"
              fullWidth={true}
              sx={{
                "& .MuiOutlinedInput-input.MuiInputBase-inputSizeSmall": {
                  fontSize: "14px",
                },
                "& .MuiInputBase-root ": {
                  lineHeight: "0.6rem",
                },
              }}
              type={visibility ? "password" : "text"}
              helperText={error.password}
              error={error.password}
              onChange={(e) => handleChange(e)}
              InputProps={{
                endAdornment: visibility ? (
                  <VisibilityOffIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setVisibility(!visibility);
                    }}
                  />
                ) : (
                  <VisibilityIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setVisibility(!visibility);
                    }}
                  />
                ),
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2} px={2} mt={1}>
        <Grid item xs={12}>
          <Box letiant="standard" style={{ width: "100%" }}>
            <InputLabel
              shrink
              htmlFor="bootstrap-input"
              style={{ paddingLeft: "0px", fontSize: "16px" }}
            >
              {t("LVLDAC0030")}
              <span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              name="confirmPassword"
              placeholder={t("LVLDAC0030")}
              autoComplete="new-password"
              size="small"
              fullWidth={true}
              sx={{
                "& .MuiOutlinedInput-input.MuiInputBase-inputSizeSmall": {
                  fontSize: "14px",
                },
                "& .MuiInputBase-root ": {
                  lineHeight: "0.6rem",
                },
              }}
              type={confirmVisibility ? "password" : "text"}
              error={error.confirmPassword}
              helperText={error.confirmPassword}
              onChange={(e) => handleChange(e)}
              InputProps={{
                endAdornment: confirmVisibility ? (
                  <VisibilityOffIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setConfirmVisibility(!confirmVisibility);
                    }}
                  />
                ) : (
                  <VisibilityIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setConfirmVisibility(!confirmVisibility);
                    }}
                  />
                ),
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Box
        sx={{
          flexWrap: "wrap",
          justifyContent: "flex-start",
          alignContent: "center",

          pt: 4,
          pb: 12,
        }}
      >
        <Button
          id="ActivateAccount1"
          onClick={handleSubmit}
          style={{
            width: "100%",
            backgroundColor: "#6495ED",
            borderRadius: "4px",
            color: "white",
            height: "40px",
            fontSize: 15,
            fontStyle: "normal",
            border: "none",
            cursor: "pointer",
            overflow: "visible",
            "&:hover": {
              backgroundColor: "red",
            },
          }}
        >
          {t("LVLOT0016")}
        </Button>
      </Box>
    </OnboardLayout>
  );
}
